/**
 * This page lists all triggers within a project.
 */

import {WHITE} from '@wandb/weave/common/css/globals.styles';
import React from 'react';

import {useFetchProjectTriggersQuery} from '../../../generated/graphql';
import {ProjectData} from '../../../state/graphql/projectPageQuery';
import {propagateErrorsContext} from '../../../util/errors';
import {AutomationsIntercomChatButton} from '../../IntercomChatButton';
import {getProjectTriggerDrawerInit} from './CreateTriggerDrawer/EventStore';
import {TriggersHeader} from './TriggersHeader';
import * as S from './TriggersPage.styles';
import {TriggersTable} from './TriggersTable/TriggersTable';
import {ZeroTriggers} from './ZeroTriggers';

type TriggersPageProps = {
  entityName: string;
  project: ProjectData;
};

export const TriggersPage = ({entityName, project}: TriggersPageProps) => {
  const projectTriggersQuery = useFetchProjectTriggersQuery({
    variables: {projectName: project.name, entityName},
    context: propagateErrorsContext(),
  });

  const triggers = projectTriggersQuery.data?.project?.triggers ?? [];

  const style: React.CSSProperties = {};
  if (triggers.length === 0) {
    style.backgroundColor = WHITE;
    style.height = '100%';
  }

  return (
    <S.Content style={style}>
      <TriggersHeader
        entityName={entityName}
        projectID={project.id}
        projectName={project.name}
        refetchTriggers={projectTriggersQuery.refetch}
      />
      {triggers.length === 0 ? (
        <ZeroTriggers />
      ) : (
        <TriggersTable
          projectTriggersQuery={projectTriggersQuery}
          baseTriggerDrawerInit={getProjectTriggerDrawerInit(
            entityName,
            project.id,
            project.name,
            [] // TODO: get existing automations
          )}
        />
      )}
      <AutomationsIntercomChatButton />
    </S.Content>
  );
};
